module.exports = {
    PASSWORD_CONFIRM_PASSWORD_SAME_VALIDATION: "Password and confirm password must be same.",
    CARD_NOTE: "Don't worry your card information will never directly touch our servers.",
}